/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

import { sumBy, filter } from 'lodash';

import { RECEIVED_ACCOUNTS } from './AccountBalancesActions';
import { RECEIVED_WORKPLACE_YEAR_END_BALANCE } from 'state/account/RpsAccountBalancesActions';
import { percentChange } from 'services/Calculation';

export const rpsBalancesInitialState = {
  aggregate: 0.0,
  dailyChange: 0.0,
  dailyRate: 0.0,
  accounts: []
};

export const rpsAccountBalancesReducer = (
  state = rpsBalancesInitialState,
  action
) => {
  if (action.type === RECEIVED_ACCOUNTS) {
    const { rpsAccounts } = action;
    if (rpsAccounts) {
      const filteredRpsAccounts = filter(rpsAccounts, (a) => !a.purgedAccount);
      return {
        aggregate: sumBy(filteredRpsAccounts, 'balanceValue'),
        dailyChange: sumBy(
          filteredRpsAccounts,
          (account) => account.balanceValue - account.previousBalanceValue
        ),
        accounts: filteredRpsAccounts,
        dailyRate: percentChange(
          sumBy(filteredRpsAccounts, (account) => account.balanceValue),
          sumBy(filteredRpsAccounts, (account) => account.previousBalanceValue)
        )
      };
    }
  }

  return state;
};
rpsAccountBalancesReducer.priority = 17;

export const workplaceYearEndBalanceInitialState = null;

export const workplaceYearEndBalanceReducer = (state = {}, action) => {
  const { type } = action;

  if (type === RECEIVED_WORKPLACE_YEAR_END_BALANCE) {
    const { payload } = action;
    if (payload) {
      return payload;
    }

    return state;
  }

  return state;
};
